export default __webpack_public_path__ + "static/media/header-small.616207de.jpg";